class MadRetailerGrid {
  constructor() {
    this.$container = jQuery(".mad-retailer-grid");
    this.$select = jQuery(".mad-retailer-filter select");
    this.$buttons = jQuery(".mad-retailer-filter__button");
    this.$items = jQuery(".mad-retailer-grid__item");
    this.$globalButton = this.$buttons.filter('[data-location-slug="all"]'); // Global button

    window.$dependencyManager.addDependencyCallback("select2", () => {
      this.$select.select2({
        allowClear: true,
      });
    });

    this.bindEvents();
  }

  bindEvents() {
    // Handle location selection from the dropdown
    this.$select.on("change", () => {
      const selectedLocation = this.$select.val() || "all"; // Default to 'all'
      this.filterRetailers(selectedLocation);
      this.setActiveButton(selectedLocation);
    });

    // Handle location selection from the buttons
    this.$buttons.on("click", (e) => {
      e.preventDefault();
      const $clickedButton = jQuery(e.currentTarget);
      const selectedLocation = $clickedButton.data("location-slug");

      // If clicking the active button, reset to "all"
      if ($clickedButton.hasClass("active")) {
        this.filterRetailers("all");
        this.setSelectValue("all");
        this.setActiveButton("all");
      } else {
        // Normal behavior: filter by this location
        this.filterRetailers(selectedLocation);
        this.setSelectValue(selectedLocation);
        this.setActiveButton(selectedLocation);
      }
    });
  }

  filterRetailers(selectedLocation) {
    this.$items.each((_, item) => {
      const $item = jQuery(item);
      const itemLocations = $item.data("retailer-location");
      const match =
        selectedLocation === "all" ||
        (itemLocations && itemLocations.split(",").includes(selectedLocation));

      $item.toggleClass("disabled", !match);
    });
  }

  setActiveButton(selectedLocation) {
    this.$buttons.removeClass("active");

    if (selectedLocation === "all") {
      this.$globalButton.addClass("active");
    } else {
      this.$buttons
        .filter((_, btn) => {
          return jQuery(btn).data("location-slug") === selectedLocation;
        })
        .addClass("active");
    }
  }

  setSelectValue(selectedLocation) {
    this.$select
      .val(selectedLocation === "all" ? "" : selectedLocation)
      .trigger("change");
  }
}

jQuery(document).ready(() => {
  if (jQuery(".mad-retailer-grid").length > 0) {
    new MadRetailerGrid();
  }
});
